import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import DropDown from "./DropDown";
import { Icon } from "@iconify/react/dist/iconify.js";
import LanguageSelector from "../LenguageSelector/lenguageSelector";
import { useTranslation } from "react-i18next"; // Importamos useTranslation
import { motion } from "framer-motion";

export default function Header({
  logoUrl,
  colorVariant,
  cart,
  actionBtnText,
  actionBtnUrl,
  darkMode,
}) {
  const { t } = useTranslation(); // Agregamos el hook useTranslation
  const [isSticky, setIsSticky] = useState(false);
  const [mobileToggle, setMobileToggle] = useState(false);
  
  const closeMobileMenu = () => {
    setMobileToggle(false);
  };
  
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    // Cleanup function to remove the event listener
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  
  return (
    <motion.header
      initial={{ y: -100, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.5, ease: "easeOut" }}
      className={`cs_site_header cs_style_1 cs_sticky_header ${
        colorVariant ? colorVariant : "cs_primary_color"
      } ${isSticky ? "cs_gescout_show" : ""}`}
    >
      <div className="cs_main_header">
        <div className="container">
          <div className="cs_main_header_in">
            <div className="cs_main_header_left">
              <Link className="cs_site_branding" to="/digital-agency" onClick={closeMobileMenu}>
                <img src={logoUrl} alt="Logo" />
              </Link>
            </div>
            <div className="cs_main_header_center">
              <div className="cs_nav cs_medium cs_primary_font">
                <ul
                  className={`${
                    mobileToggle ? "cs_nav_list cs_active" : "cs_nav_list"
                  }`}
                >
                  <li>
                    <Link to="/digital-agency" onClick={closeMobileMenu}>{t('header.home')}</Link>
                  </li>
                  <li>
                    <Link to="/about" onClick={closeMobileMenu}>{t('header.about')}</Link>
                  </li>
                  {/* <li className="menu-item-has-children">
                    <Link to="blog">{t('header.blog')}</Link>
                    <DropDown>
                      <ul>
                        <li>
                          <Link to="blog-list">{t('header.blogList')}</Link>
                        </li>
                      </ul>
                    </DropDown>
                  </li> */}
                  <li className="menu-item-has-children">
                    <Link onClick={closeMobileMenu}>{t('header.services')}</Link>
                    <DropDown>
                      <ul>
                        <li>
                          <Link to="portfolio" onClick={closeMobileMenu}>{t('services.menuItems.webDevelopment')}</Link>
                        </li>
                        <li>
                          <Link to="portfolio/portfolio-details" onClick={closeMobileMenu}>
                            {t('services.menuItems.digitalMarketing')}
                          </Link>
                        </li>
                        <li>
                          <Link to="case-study-details" onClick={closeMobileMenu}>
                            {t('services.menuItems.merchandiseDesign')}
                          </Link>
                        </li>
                        <li>
                          <Link to="blog" onClick={closeMobileMenu}>{t('services.menuItems.events')}</Link>
                        </li>
                        <li>
                          <Link to="blog/blog-details" onClick={closeMobileMenu}>{t('services.menuItems.staff')}</Link>
                        </li>
                      </ul>
                    </DropDown>
                  </li>
                  <li>
                    <Link to="contact" onClick={closeMobileMenu}>{t('header.contact')}</Link>
                  </li>
                  <li className="cs_mobile_only">
                    <a
                      href="tel:+17866429950"
                      className="cs_color_orange_800 cs_extra_bold cs_fs_20"
                      onClick={closeMobileMenu}
                    >
                      <Icon icon="fa-solid:phone" className="cs_extra_bold fs-5 m-2" />
                      {t('header.phoneNumber')}
                    </a>
                  </li>
                </ul>
                <span
                  className={
                    mobileToggle
                      ? "cs_menu_toggle cs_teggle_active"
                      : "cs_menu_toggle"
                  }
                  onClick={() => setMobileToggle(!mobileToggle)}
                >
                  <span></span>
                </span>
              </div>
            </div>
            <div className="cs_main_header_right d-flex align-items-center">
              <div className="me-3"> {/* Margen a la derecha del selector */}
                <LanguageSelector darkMode={darkMode} />
              </div>
              <a
                href="tel:+17866429950"
                className="cs_color_orange_800 cs_extra_bold cs_fs_20 cs_hide_mobile"
              >
                <Icon icon="fa-solid:phone" className="cs_extra_bold fs-5 m-2" />
                {t('header.phoneNumber')}
              </a>
            </div>
          </div>
        </div>
      </div>
    </motion.header>
  );
}
